import React, { useState } from "react";
import { Modal, Button } from "react-bootstrap";
import { FaMicrophone, FaPaperPlane, FaUpload } from "react-icons/fa";
import axios from "axios";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import config from "../../config/config";
import { getAuthToken } from "../../utils/token";
const DiscrepancyModal = ({ show, handleClose }) => {
  const [form, setForm] = useState({
    units: 0,
    reason: "",
  });
  const [localCount, setLocalCount] = useState(0);
  const [localNotes, setLocalNotes] = useState("");
  const handleIncrease = () => {
    setLocalCount((prev) => prev + 1);
    setForm((prev) => ({ ...prev, units: prev.units + 1 }));
  };

  const handleDecrease = () => {
    setLocalCount((prev) => (prev > 0 ? prev - 1 : 0));
    setForm((prev) => ({
      ...prev,
      units: prev.units > 0 ? prev.units - 1 : 0,
    }));
  };
  const handleCountChange = (e) => {
    const val = Number(e.target.value) || 0;
    setLocalCount(val);
    setForm((prev) => ({ ...prev, units: val }));
  };
  const handleSubmit = async () => {
    const token = getAuthToken();
    if (!token) {
      toast.error("Authentication token missing!");
      return;
    }
    try {
      const payload = {
        units: form.units,
        reason: localNotes,
      };
      const response = await axios.post(
        `${config.API}/operator/discrepency`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      const { success, message } = response.data;
      if (success === true) {
        toast.success(message || "Request submitted successfully!");
        setForm({ units: 0, reason: "" });
        setLocalCount(0);
        setLocalNotes("");
        handleClose();
      } else if (success === false) {
        toast.error(message || "Something went wrong!");
      }
    } catch (err) {
      console.error("Error submitting material issue:", err.message);
      toast.error("Failed to submit material issue request!");
    }
  };

  return (
    <Modal show={show} onHide={handleClose} centered size="lg">
      <Modal.Header closeButton>
          <h2 className="font_family">Discrepancy Logging</h2>
      </Modal.Header>
      <Modal.Body className="">
        <div className="quantity-control d-flex align-items-center justify-content-between border rounded px-2 py-1 mt-3 font_family">
          <button className="qty-btn" onClick={handleDecrease}>
            −
          </button>
          <input
            type="text"
            className="text-center fw-bold"
            style={{
              border: "none",
              boxShadow: "none",
              outline: "none",
              backgroundColor: "transparent",
              width: "50px",
            }}
            value={localCount}
            onChange={handleCountChange}
          />
          <button className="qty-btn" onClick={handleIncrease}>
            +
          </button>
        </div>
        <div className="border rounded p-3 mb-3 mt-4">
          <div className="bg-secondary-subtle text-muted p-3 rounded mb-3 w-75">
            Please describe the discrepancy in your Shift Report. You can
            provide details about what you're seeing, upload an image, or use
            voice input.
          </div>
          <div className="border rounded p-2">
            <div className="d-flex align-items-center">
              <div className="d-flex gap-2">
                <Button variant="light" className="border">
                  <FaUpload />
                </Button>
                <Button variant="light" className="border">
                  <FaMicrophone />
                </Button>
              </div>
              <div className="flex-grow-1 mx-2">
                <textarea
                  className="form-control border-0 shadow-none"
                  rows="1"
                  placeholder="Type here..."
                  style={{ resize: "none" }}
                  value={localNotes}
                  onChange={(e) => setLocalNotes(e.target.value)}
                />
              </div>
              <div>
                <Button variant="primary" onClick={handleSubmit}>
                  <FaPaperPlane />
                </Button>
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default DiscrepancyModal;
